import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFacebookComponent } from "./med-icon-facebook.component";

@NgModule({
  declarations: [
    MedIconFacebookComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFacebookComponent,
  ],
})
export class MedIconFacebookModule { }
